import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

export class LocalizedDateFnsUtils extends DateFnsUtils {
  getDatePickerHeaderText(date: Date) {
    return format(date, "yyyy年 MM月 dd日", { locale: this.locale });
  }
}
